<template>
  <v-form
  class="mx-10 mb-10 pa-10 text-center"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-5 text-primary">Import Certificate</h3>
    <v-layout>
      <v-flex md4>
        <v-autocomplete
            background-color="rgba(255,255,255)"
            v-model="selectKeystore"
            :items="keystoresOPTIONS"
            item-text="id"
            item-value="id"
            label="Target keyStoreId"
            outlined
            dense
        ></v-autocomplete>
        <v-autocomplete
            background-color="rgba(255,255,255)"
            v-model="selectProfile"
            :items="profileOPTIONS"
            item-text="friendlyName"
            item-value="name"
            label="Target Profile"
            outlined
            dense
        ></v-autocomplete>
        <v-autocomplete
            background-color="rgba(255,255,255)"
            v-model="selectSecPolTmpl"
            :items="secPolTmplOPTIONS"
            label="SecPolTmpl"
            outlined
            dense
        ></v-autocomplete>
        <v-textarea
            background-color="rgba(255,255,255)"
            outlined
            no-resize
            v-model="localCertificateToImport"
            height="100px"
            name="input-7-4"
            label="Certificate To Import"
        ></v-textarea>
        <v-divider></v-divider>
        <v-textarea
        background-color="#999999"
            name="input-7-1"
            label="Parameters"
            class="mt-10"
            no-resize
            height="150px"
            v-model="requestPayload"
            outlined
        ></v-textarea>

      </v-flex>
      <v-flex md2>
        <v-btn
            class="mr-4"
            :disabled="!valid"
            color="#007CA4"
            @click="validate"
            dark>
          Import Certificate >>
        </v-btn>
      </v-flex>
      <v-flex md6>
        <v-textarea
            background-color="rgba(255,255,255)"
            name="input-7-1"
            label="Response"
            no-resize
            height="550px"
            v-model="response"
            outlined
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'
  export default {
    props:["data", "config", "certificateToImport"],
    data: () => ({
      valid: true,
      requestPayload: '{}',
      response: '',
      localCertificateToImport:'{"keyStoreId":"PFX","profileName":"-Select-"}',
      selectKeystore:"",
      selectSecPolTmpl:"",
      selectProfile:"",
      keystoresOPTIONS:[],
      secPolTmplOPTIONS:[],
      profileOPTIONS:[],
      itemskeyOptions: [
          '1024','2048','4096'
      ],
    }),
    mounted(){
      if (this.config) {
        this.localCertificateToImport = JSON.parse(this.config.certificateToImport)
        this.keystoresOPTIONS = this.config.keyStoreIds
        this.selectKeystore = this.config.keyStore
        this.profileOPTIONS = this.config.profileOPTIONS
        this.selectProfile = this.config.profile
        this.secPolTmplOPTIONS = this.config.secPolTmplOPTIONS
        this.selectSecPolTmpl = this.config.selectSecPolTmpl
				this.updateRequest('certificateToImport', null , JSON.parse(this.config.certificateToImport))
      }
      this.listKeystores();
      this.keystoresOPTIONS = this.objectToArray(this.data.keystoresOPTIONS)
    },

    watch: {
      selectKeystore(value){
        this.updateRequest('keyStore','id',value)
        let securityPolicyList = this.setSecurityPolicyOptions(value)
        this.secPolTmplOPTIONS = this.objectToArray(this.data[securityPolicyList])
        this.getKeyStoreInfo(value)
      },
      selectSecPolTmpl(value){
        this.updateRequest('securityPolicy',null,JSON.parse(value))
      },
      selectProfile(value){
        this.updateRequest('keyStore','profile',value)
      },
      localCertificateToImport(value){
        this.updateRequest('certificateToImport', null , JSON.parse(value))
      }
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      setSecurityPolicyOptions(keyStore){
        let response
        switch (keyStore) {
          case "WIN-ENH":
            response = 'securityPolicyCAPI'
            break;

          case "CSK":
            response = 'securityPolicyCSK'
          break;

          case "PFX":
            response = 'securityPolicyPFX'
          break;
          
          case "MACOS" || "FF-NSS":
            response = 'securityPolicyEMPTY'
          break;

          default:
            response = 'securityPolicyDEVICE'
            break;
        }
        return response
      },
      updateRequest(key1, key2, param){
        let request = JSON.parse(this.requestPayload)
        if(key2){
          if(!request[key1]) request[key1] = {}
          request[key1][key2] = param;
        }else{
          request[key1] = param;
        }
        this.requestPayload = JSON.stringify(request, null, "\t");
      },
      objectToArray(objectValue){
        let newArray = []
        Object.keys(objectValue).forEach(element => {
          newArray.push({text: objectValue[element], value: element})
        });
        return newArray
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
          this.importCertificate()
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },

      importCertificate() {
        let request = JSON.parse(this.requestPayload)
        console.log(request);
        if (request.keyStore?.id) {
          alisonJS.importCertificate(request).then((certificate)=>{
                this.response = JSON.stringify(certificate);
                this.setColor('success')
                this.setSnack('Certificate imported successfully')
          }, (e)=> {
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = JSON.stringify(e, null, "\t");
            })
        } else {
          alert('All fields are required')
        }
      },

      getKeyStoreInfo(keystoreId) {
        this.profileOPTIONS = []
        alisonJS.keyStoreInfo({id:keystoreId}).then((info) => {
              this.setColor('info')
              this.setSnack('KeyStore info obtained successfully')
              this.profileOPTIONS.push({friendlyName: 'new profile', name:''})
              info.keyStores.forEach(ks => {
                  this.profileOPTIONS = this.profileOPTIONS.concat(ks.profiles)
                });
          }).catch(e=>{
              this.setColor('error')
              this.setSnack('FAILURE: ' + JSON.stringify(e))
          })
      },

      listKeystores() {
        alisonJS.listKeyStores().then((list) => {
          console.log(list)
              this.keystoresOPTIONS = list.keyStores.filter((key)=>key.capabilities.includes('I'));
              this.setColor('success')
              this.setSnack('KeyStores obtained successfully')
              // JSON.stringify(profiles, null, 4); // Indented 4 spaces
              // JSON.stringify({a:1,b:2,c:{d:1,e:[1,2]}}, null, "\t");
          }).catch((e)=>{
            console.log("error:", e)
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = JSON.stringify(e, null, "\t");
          })
      }
    },
  }
</script>
